@if (initialized) {

    <div class="surface-0 shadow-1 border-round p-3">

        <!-- Toolbar: account selector, metric toggle, time range -->
        <div class="flex flex-wrap gap-3 justify-content-between align-items-center mb-3">
            <div class="flex flex-column">
                <span class="font-semibold text-lg">Transaktionsauswertung</span>
                <span class="text-600 text-sm">
                    Forderungen und Gutschriften je Buchungstag für das gewählte Bankkonto
                </span>
            </div>

            <div class="flex flex-wrap gap-2 align-items-center">
                <p-select
                        [options]="accounts"
                        [(ngModel)]="selectedAccountId"
                        optionLabel="name"
                        optionValue="id"
                        [loading]="accountsLoading"
                        placeholder="Bankkonto wählen"
                        styleClass="w-15rem"
                        (onChange)="handleAccountChange()">
                </p-select>

                <p-selectButton
                        [options]="metricOptions"
                        [(ngModel)]="selectedMetric"
                        optionLabel="label"
                        optionValue="value"
                        [allowEmpty]="false"
                        (onChange)="handleMetricChange()">
                </p-selectButton>

                <mvs-range-selector-overlay
                        fieldName="e.bookingDate"
                        placeholder="Zeitraum wählen"
                        dateMode="localDate"
                        [defaultFilterDate]="FilterDate.CALENDAR_WEEK"
                        [filterDate]="FilterDate.CALENDAR_WEEK"
                        (onChangeFilterValues)="handleRangeValues($event)">
                </mvs-range-selector-overlay>
            </div>
        </div>

        @if (!accounts.length) {
            <div class="p-4 text-center text-600">
                Für diesen Gläubiger sind keine Bankkonten vorhanden.
            </div>
        } @else if (chartWidget) {
            <mvs-widget [widgetData]="chartWidget"></mvs-widget>
        }

    </div>

}
